import React from 'react'

export default function Estadisticas() {
  return (
    <div>Estadisticas</div>
  )
}
